/* Luvana · Bundle-Auswahl und Kaufknopf (ersetzt die App-Logik der Vorlage).
   Werte kommen aus data-Attributen des Snippets: Varianten, Zugaben, Routen. */
(function () {
  function init() {
    var root = document.querySelector('[data-luvana-bundle]');
    if (!root) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.cc-offer-card'));
    var btn = document.querySelector('.custom_checkout_button_landing_page');
    var tabs = btn ? Array.prototype.slice.call(btn.querySelectorAll('.price_trigger')) : [];
    function setActive(i) {
      cards.forEach(function (c, k) { c.classList.toggle('cc-offer-card--active', k === i); });
      tabs.forEach(function (t, k) { t.style.display = (k === i) ? '' : 'none'; });
      root.setAttribute('data-active', String(i));
    }
    cards.forEach(function (c, k) { c.addEventListener('click', function () { setActive(k); }); });
    setActive(parseInt(root.getAttribute('data-default') || '1', 10));
    if (!btn) return;
    // Sticky-Leiste „Nu Bestellen“: gewähltes Paket direkt in den Warenkorb und zur Kasse (wie der Hauptknopf)
    Array.prototype.forEach.call(document.querySelectorAll('.sticky-bar__button'), function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); btn.click(); });
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (btn.getAttribute('data-busy') === '1') return;
      var card = cards[parseInt(root.getAttribute('data-active'), 10)];
      if (!card) return;
      var items = [{ id: Number(card.getAttribute('data-variant-id')), quantity: 1 }];
      (card.getAttribute('data-gifts') || '').split(',').filter(Boolean).forEach(function (g) {
        items.push({ id: Number(g), quantity: 1 });
      });
      btn.setAttribute('data-busy', '1'); btn.classList.add('loading_hk'); btn.style.pointerEvents = 'none';
      fetch(root.getAttribute('data-cart-add-url') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('cart/add'); return r.json(); })
        .then(function () { window.location.assign(root.getAttribute('data-checkout-url')); })
        .catch(function () { btn.setAttribute('data-busy', ''); btn.classList.remove('loading_hk'); btn.style.pointerEvents = ''; });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
